export default __webpack_public_path__ + "resources/icons/d432-4e99.png";